import { TableCell } from "@material-ui/core";
import React from "react";
import { Link } from "react-router-dom";
export default function LinkWrapper(props) {
  const { to, children, style, disabled, className = "" } = props;

  let styleSheet = {
    // color: "#F95A3F",
    cursor: "pointer",
    ...style,
  };
  // }

  //If link is disabled, remove pointer and color
  if (disabled) {
    styleSheet = style;
  }

  return (
    <TableCell className={"ellipsis" + className}>
      <span>
        <Link className="redirect-link-wrapper" to={to}>
          {children}
        </Link>
      </span>
    </TableCell>
  );
}
